import * as React from "react";
import { singleton } from "logic/singleton";
const defaultContext = {
  dashboardPage: void 0,
  setDashboardPage: () => void 0,
  unsetDashboardPage: () => void 0
};
const DashboardPageContext = React.createContext(defaultContext);
export default singleton("contexts.DashboardPage", () => DashboardPageContext);
